import {
  resolveVisibleNavigationGroups,
  shigoNavigationGroups,
} from '../../components/navigation/shigo-navigation.config';
import {
  ShigoNavigationItem,
  type ShigoNavigationAccessContext,
} from '../../components/navigation/shigo-navigation.types';
import { SearchEntityKind } from './model';

const ENTITY_KIND_BY_NAVIGATION_ITEM: Partial<Record<ShigoNavigationItem, SearchEntityKind>> = {
  [ShigoNavigationItem.SupplyPublishers]: SearchEntityKind.Publisher,
  [ShigoNavigationItem.SupplyPlacements]: SearchEntityKind.Placement,
  [ShigoNavigationItem.DemandPartners]: SearchEntityKind.DemandPartner,
  [ShigoNavigationItem.DemandIntegrations]: SearchEntityKind.Integration,
};

export function searchableEntityKinds(
  context: ShigoNavigationAccessContext,
): ReadonlySet<SearchEntityKind> {
  const kinds = new Set<SearchEntityKind>();
  for (const group of resolveVisibleNavigationGroups(shigoNavigationGroups, context)) {
    for (const entry of group.entries) {
      const kind = ENTITY_KIND_BY_NAVIGATION_ITEM[entry.id];
      if (kind) kinds.add(kind);
    }
  }
  return kinds;
}
